import React, {useState, useEffect} from 'react'
import {
  Route,
  Switch,
  BrowserRouter as Router
} from 'react-router-dom'
import axios from 'axios'
import {Helmet} from "react-helmet"
import { useIdleTimer } from 'react-idle-timer'
import { Icon, Label, Popup } from 'semantic-ui-react'
import {WindowURL,WindowLocation,WindowReload} from '../config/settings'
import Alertmessage from '../config/alert'

import AppForm from './pages_dev/app'

import OpenAccountStep1 from './pages/steps1'
import OpenAccountStep2 from './pages/steps2'
import OpenAccountStep3 from './pages/steps3'
import OpenAccountStep4Individual from './pages/steps4_individual'
import OpenAccountStep4Joints from './pages/steps4_joints'
import OpenAccountStep5Financials from './pages/steps5_financial'
import OpenAccountDocument from './pages/steps6_document'

import CustomerLogin from './login/login'


import WebsiteMenu from './web/menu'
import WebsiteFooter from './web/footer'
import WebsiteSubContent from './web/subcontent'



export default function AppApplication(props) {

  const [alert,setalert] = useState(false);
  const [Alertcontent,setAlertcontent] = useState({});
  function Alertclose(){setalert(false);}
  function Alertconfirm(data){if(data.confirm==true){setalert(false);}}
  function Alertdelete(data){
    if(data.delete==true){
    }
  }

	function AddCustomClassBody(){
    document.body.classList.add("application");
  }
  function AddCustomClassBody(){
    document.body.classList.add("pages");
  }

  function ActiveMenu(){
    let path = window.location.pathname;
    var url=path.split('/');
    return url[2];
  }


  /*-------------------------------------
    Content
  --------------------------------------*/
  const [content, setcontent] = useState({
    root_app: {
      app_form: '',
      app_login:'',
    }
  });
  function ContentApplication(){
    setAlertcontent({intent:'inline_spinner',settings:{centered:true,icon:'spinner',title:'Loading',html:"This won't take long, please wait...",footer:'none'}});
    setalert(true);
    let formData = new FormData();
    formData.append('type','content');
    axios.post('/content/request.php',formData)
    .then(function (response) {
        let obj = response.data;
        setcontent({
          ...content,
          root_app: {
            app_form: obj.root_app.app_form,
            app_login:obj.root_app.app_login,
          }
        });
        setalert(false);
    })
    .catch(function (error){
      setAlertcontent({intent:'alert',settings:{centered:false,icon:'warning',title:'Server Error',html:"Problem connecting to the server."}});
      setalert(true);
      setTimeout(function() {setalert(false);},2000);
    });
  }



  /*-----------------------------------------------------------------------
    User Idle
  -------------------------------------------------------------------------*/
  function SesstionTimeout(){

    setAlertcontent({intent:'inline_spinner',settings:{centered:true,icon:'spinner',title:'Session Timeout!',html:"This won't take long to refresh, please wait...",footer:'none'}});
    setalert(true);

    let formData = new FormData();
    formData.append('type','session_idle');
    axios.post('/application/idle.php',formData)
    .then(function (response) {
        let obj = response.data;
        setalert(false);
        WindowReload();

    })
    .catch(function (error){
      setalert(false);
    });
  }


  const handleOnIdle = event => {
    //console.log('user is idle', event)
    //console.log('last active', getLastActiveTime());
    SesstionTimeout();
  }

  const handleOnActive = event => {
    //console.log('user is active', event)
    //console.log('time remaining', getRemainingTime())
    //setalert(true);
  }

  const handleOnAction = (e) => {
    //setalert(false);
  }

  const { getRemainingTime, getLastActiveTime } = useIdleTimer({
    timeout: 1000 * 60 * 15,
    onIdle: handleOnIdle,
    onActive: handleOnActive,
    onAction: handleOnAction,
    debounce: 500
  });


  useEffect(()=>{
    ContentApplication();
    AddCustomClassBody();
  },[]);

	return (
    <React.Fragment>

      {alert&&<Alertmessage close={Alertclose} data={Alertcontent} confirm={Alertconfirm} delete={Alertdelete}/>}

      <Helmet>
          <title>Prime Capital Markets - Online Application</title>
      </Helmet>


      <WebsiteMenu />


       <div className="open-account-wrapper">
			    <div className="wrapper">
            <div className="app-account-wrapper" id="ElementScroll">
              <div className="app-account-body">
    						<Router>
    							<Switch>
    								<Route exact path={WindowURL('/')}  component={AppForm}/>
                    <Route exact path={WindowURL('/member-login')}  component={CustomerLogin}/>
    							</Switch>
    						</Router>
              </div>
            </div>
					</div>
			 </div>

       <WebsiteFooter />


    </React.Fragment>
	)
}
